export const faqSections = [
  {
    title: "Projekt & Ablauf",
    items: [
      {
        id: "projektablauf",
        question: "Wie läuft ein Projekt mit datacook ab?",
        answer:
          "Wir starten mit einem klaren Verständnis Ihrer Ausgangslage, Ziele und Engpässe. Danach strukturieren wir Anforderungen, priorisieren den größten Hebel und setzen in nachvollziehbaren Schritten um. Wichtig ist uns, dass Sie jederzeit Transparenz über Stand, Entscheidungen und nächste Schritte haben.",
      },
      {
        id: "zielgruppen",
        question: "Für welche Unternehmen arbeitet datacook?",
        answer:
          "Wir arbeiten vor allem mit kleinen und mittleren Unternehmen, die ihre Prozesse modernisieren, Systeme besser verbinden oder neue digitale Lösungen aufbauen möchten. Besonders relevant sind Projekte dort, wo Standardsoftware nicht ausreicht oder bestehende Abläufe zu viel manuelle Arbeit erzeugen.",
      },
      {
        id: "projektstart",
        question: "Wie schnell kann ein Projekt starten?",
        answer:
          "Das hängt von Umfang und Priorität ab. Kleinere Vorhaben können oft kurzfristig starten, größere Projekte benötigen eine saubere Vorbereitungsphase. Entscheidend ist, dass wir den Einstieg so strukturieren, dass schnell Klarheit und ein belastbarer Umsetzungsplan entstehen.",
      },
      {
        id: "bestehende-systeme",
        question: "Arbeitet ihr auch mit bestehenden Systemen?",
        answer:
          "Ja. In vielen Projekten geht es gerade darum, bestehende Systeme sinnvoll zu erweitern, anzubinden oder technisch zu entlasten. Wir prüfen, was übernommen werden kann, wo Anbindungen sinnvoll sind und an welchen Stellen ein gezielter Neubau mehr Nutzen bringt.",
      },
      {
        id: "umsetzungsdauer",
        question: "Wie lange dauert die Umsetzung?",
        answer:
          "Die Dauer richtet sich nach Komplexität, Abhängigkeiten und Zielbild. Kleine Lösungen oder klar umrissene Erweiterungen können in wenigen Wochen entstehen, größere Plattform- oder Integrationsprojekte dauern entsprechend länger. Wir arbeiten dabei bewusst in Etappen, damit früh nutzbare Ergebnisse entstehen.",
      },
    ],
  },
  {
    title: "Technik & Betrieb",
    items: [
      {
        id: "leistungen",
        question: "Welche Leistungen bietet datacook konkret an?",
        answer:
          "Unser Schwerpunkt liegt auf Softwareentwicklung, Systemanbindungen, Prozessautomatisierung, Web-Lösungen, Reporting sowie ausgewählten Themen rund um Cloud, Architektur und IT-Security. Wir verbinden strategisches Verständnis mit technischer Umsetzung und bauen Lösungen entlang realer Geschäftsprozesse.",
      },
      {
        id: "schnittstellen",
        question: "Könnt ihr ERP-, CRM- oder DATEV-Systeme anbinden?",
        answer:
          "Ja. Systemanbindungen gehören zu unseren Kernleistungen. Wir verbinden ERP-, CRM-, DATEV-nahe oder andere Fachsysteme so, dass Daten verlässlich zwischen ihnen fließen und doppelte Pflege oder manuelle Übergaben reduziert werden.",
      },
      {
        id: "cloud-migration",
        question: "Übernehmt ihr auch Cloud Migrationen?",
        answer:
          "Ja. Wir begleiten Cloud-Migrationen strukturiert und mit Blick auf Betrieb, Sicherheit und zukünftige Skalierbarkeit. Dabei geht es nicht nur um Technik, sondern auch um Rechte, Datenflüsse, Übergänge und die Stabilität im laufenden Geschäft.",
      },
      {
        id: "security-dsgvo",
        question: "Wie unterstützt ihr bei IT-Security und DSGVO?",
        answer:
          "Wir helfen dabei, Systeme und Prozesse so aufzubauen, dass Sicherheitsanforderungen und Datenschutz frühzeitig berücksichtigt werden. Das umfasst technische Struktur, Rollen- und Rechtekonzepte, Datenflüsse sowie pragmatische Maßnahmen, die in der Praxis tragfähig sind.",
      },
      {
        id: "support-go-live",
        question: "Bietet ihr auch Support nach dem Go-live an?",
        answer:
          "Ja. Nach dem Go-live unterstützen wir bei Stabilisierung, Weiterentwicklung und Betrieb. Gerade bei individuellen Lösungen ist es wichtig, dass Optimierungen, Fehlerbehebungen und neue Anforderungen sauber weitergeführt werden können.",
      },
    ],
  },
];

export const allFaqItems = faqSections.flatMap((section) => section.items);
